/**
 * Cola durable de hechos local-confirmed pendientes de acuse remoto
 * (FR-SYNC-2, FR-SYNC-3, FR-SYNC-9; ADR OQ-1 condicion 4: ninguna
 * reconstruccion descarta un hecho local confirmado sin acuse).
 */

import type { LocalStore, StoredItem } from "./local-store.js";

const OUTBOX_COLLECTION = "outbox";

export type OutboxItemKind = "entry" | "metadata_op";

export interface OutboxItem {
  readonly id: string; // entryId u opId, segun kind
  readonly kind: OutboxItemKind;
  readonly enqueuedAt: string;
  readonly attempts: number;
  readonly lastError: string | null;
}

export class Outbox {
  constructor(private readonly store: LocalStore) {}

  async enqueue(id: string, kind: OutboxItemKind, enqueuedAt: string): Promise<void> {
    const item: OutboxItem = { id, kind, enqueuedAt, attempts: 0, lastError: null };
    const entry: StoredItem<OutboxItem> = { id, value: item };
    await this.store.putBatch(OUTBOX_COLLECTION, [entry]);
  }

  async listPending(): Promise<OutboxItem[]> {
    const items = await this.store.list<OutboxItem>(OUTBOX_COLLECTION);
    return items.map((i) => i.value);
  }

  /** Se llama solo tras verificar la insercion en el sistema de registro (F3). */
  async acknowledge(id: string): Promise<void> {
    await this.store.delete(OUTBOX_COLLECTION, id);
  }

  async recordAttemptFailure(id: string, error: string): Promise<void> {
    const current = await this.store.get<OutboxItem>(OUTBOX_COLLECTION, id);
    if (!current) return;
    const updated: OutboxItem = { ...current, attempts: current.attempts + 1, lastError: error };
    await this.store.putBatch(OUTBOX_COLLECTION, [{ id, value: updated }]);
  }
}
